import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'nb-spinner-sizes',
  templateUrl: './spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {

  constructor() { }

  ngOnInit(): void {
  }

}
